module.exports = __webpack_public_path__ + "img/logo.2c2e49bb.svg";